import { createSlice } from '@reduxjs/toolkit';
import { IActivity } from '../../../../dto';
import { setActivities } from '../actions';
import { MN_ACTIVITIES, TYPE_LIST } from '../../../../common';

export interface ActivitiesState {
  data: IActivity[];
  loading: boolean;
  error: string | null;
}

const initialState: ActivitiesState = {
  data: [],
  loading: false,
  error: null,
};

export const activitiesSlice = createSlice({
  name: `${MN_ACTIVITIES}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setActivities, (state, { payload }) => {
      state.data = payload;
    });
  },
});
